// The Top Reviewers leaderboard.
//
// It ranks the one signal the server actually observes and can't be spoofed past a real
// limit: how many titles an account has rated (one rating per account per title). Appearing
// is OPT-IN and privacy-respecting - a user picks a public handle (automod-checked); their
// Google name and email are never shown. Signed-out visitors can read the board but must
// sign in and set a handle to join.
//
// Rendered into the folder container as a custom view, so it inherits the active Look.

import { isSignedIn, getLeaderboard, getStanding, setHandle } from "./account.js";

function el(tag, cls, text) { const e = document.createElement(tag); if (cls) e.className = cls; if (text != null) e.textContent = text; return e; }

export function renderLeaderboard(container) {
	container.textContent = "";
	draw(container);
}

async function draw(container) {
	container.textContent = "";
	const wrap = el("div", "rv-lb");
	container.appendChild(wrap);

	wrap.appendChild(el("h2", "rv-lb-title", "Top Contributors"));
	wrap.appendChild(el("p", "rv-lb-sub", "Ranked by titles rated plus forum posts - the things the server can actually count, so it can’t be faked. Your Google name is never shown, only the public handle you choose."));

	// The signed-in panel: your standing + handle control.
	const meSlot = el("div", "rv-lb-me");
	wrap.appendChild(meSlot);
	renderMe(meSlot);

	const list = el("div", "rv-lb-list");
	wrap.appendChild(list);
	list.appendChild(el("div", "rv-lb-loading", "Loading…"));

	const board = await getLeaderboard();
	let myHandle = "";
	if (isSignedIn()) { try { myHandle = (await getStanding()).handle || ""; } catch (e) { void e; } }
	list.textContent = "";
	if (!board.length) { list.appendChild(el("div", "rv-lb-empty", "No one’s on the board yet. Rate some titles and set a handle to be first.")); return; }

	const head = el("div", "rv-lb-row rv-lb-head");
	head.append(el("span", "rv-lb-rank", "#"), el("span", "rv-lb-name", "Contributor"), el("span", "rv-lb-score", "Points"));
	list.appendChild(head);
	for (const r of board) {
		const row = el("div", "rv-lb-row" + (r.handle === myHandle ? " you" : ""));
		const rank = el("span", "rv-lb-rank");
		rank.append(medal(r.rank));
		const nameWrap = el("div", "rv-lb-namewrap");
		nameWrap.appendChild(el("span", "rv-lb-name", r.handle));
		const parts = [];
		if (r.reviews) parts.push(r.reviews + " rated");
		if (r.posts) parts.push(r.posts + " post" + (r.posts === 1 ? "" : "s"));
		if (parts.length) nameWrap.appendChild(el("span", "rv-lb-break", parts.join(" · ")));
		row.append(rank, nameWrap, el("span", "rv-lb-score", String(r.score != null ? r.score : r.reviews)));
		list.appendChild(row);
	}
}

function medal(rank) {
	if (rank <= 3) { const s = el("span", "rv-lb-medal m" + rank, String(rank)); return s; }
	return el("span", "rv-lb-rank-n", String(rank));
}

async function renderMe(slot) {
	slot.textContent = "";
	if (!isSignedIn()) {
		slot.appendChild(el("p", "rv-lb-note", "Sign in with the Account button (top right) and pick a handle to join the board."));
		return;
	}
	let standing;
	try { standing = await getStanding(); } catch (e) { void e; slot.appendChild(el("p", "rv-lb-note", "Couldn’t load your standing.")); return; }

	const card = el("div", "rv-lb-mecard");
	const breakdown = [];
	if (standing.reviews) breakdown.push(standing.reviews + " rated");
	if (standing.posts) breakdown.push(standing.posts + " post" + (standing.posts === 1 ? "" : "s"));
	const bd = breakdown.length ? breakdown.join(" · ") : "nothing yet";
	if (standing.onBoard) {
		const stat = el("div", "rv-lb-mestat");
		stat.append(el("span", "rv-lb-merank", "#" + standing.rank), el("span", "rv-lb-mesub", "of " + standing.boardSize + " · " + standing.score + " pts (" + bd + ")"));
		card.appendChild(stat);
	} else if (standing.score > 0) {
		card.appendChild(el("p", "rv-lb-note", "You’re at " + standing.score + " pts (" + bd + "). Pick a handle below to appear on the board."));
	} else {
		card.appendChild(el("p", "rv-lb-note", "Rate a title (the stars on any card) or post in the forums, then pick a handle to get on the board."));
	}

	const field = el("div", "rv-lb-handle");
	const input = el("input", "rv-lb-input");
	input.type = "text"; input.maxLength = 24; input.placeholder = "Your public handle"; input.value = standing.handle || "";
	input.autocomplete = "off"; input.spellcheck = false;
	const save = el("button", "rv-lb-save", standing.handle ? "Update" : "Set handle");
	save.type = "button";
	const err = el("div", "rv-lb-err"); err.hidden = true;
	save.addEventListener("click", async () => {
		err.hidden = true; save.disabled = true;
		try { await setHandle(input.value.trim()); draw(slot.closest(".rv-grid") || slot.parentElement); }
		catch (e) { err.textContent = e.message || "Couldn’t save."; err.hidden = false; save.disabled = false; }
	});
	field.append(input, save);
	card.append(field, err);
	if (standing.handle) {
		const clear = el("button", "rv-lb-clear", "Leave the board");
		clear.type = "button";
		clear.addEventListener("click", async () => { if (!confirm("Remove your handle from the leaderboard?")) return; try { await setHandle(""); draw(slot.closest(".rv-grid") || slot.parentElement); } catch (e) { void e; } });
		card.appendChild(clear);
	}
	slot.appendChild(card);
}
